import React from 'react';
import { FiFileText, FiCheck } from 'react-icons/fi';

const DEFAULT_CATEGORY_COLORS = {
  starter: { name: 'Starter', color: 'bg-neutral-100 text-neutral-700' },
  marketing: { name: 'Marketing', color: 'bg-pink-100 text-pink-700' },
  utility: { name: 'Utility', color: 'bg-sky-100 text-sky-700' },
  authentication: { name: 'Authentication', color: 'bg-amber-100 text-amber-700' },
  newsletter: { name: 'Newsletter', color: 'bg-blue-100 text-blue-700' },
  support: { name: 'Support', color: 'bg-emerald-100 text-emerald-700' },
  info: { name: 'Info', color: 'bg-violet-100 text-violet-700' },
};

const WhatsAppTemplateSelector = ({
  templates,
  selectedTemplateId,
  onSelectTemplate,
}) => {
  return (
    <div className="bg-neutral-50 rounded-xl p-4 h-fit border border-neutral-200 shadow-soft">
      <h2 className="text-base font-bold text-neutral-900 mb-3 flex items-center gap-2">
        <div className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-lg flex items-center justify-center">
          <FiFileText className="w-4 h-4 text-white" />
        </div>
        WhatsApp Templates
      </h2>

      {templates.length === 0 ? (
        <div className="text-center py-4">
          <div className="animate-pulse text-neutral-400 text-sm">Loading templates…</div>
        </div>
      ) : (
        <div className="space-y-2">
          {templates.map((template) => {
            const category = template.category || 'starter';
            const badge = DEFAULT_CATEGORY_COLORS[category] || {
              name: category,
              color: 'bg-neutral-100 text-neutral-700',
            };
            const isSelected = selectedTemplateId === template.id;
            return (
              <button
                key={template.id}
                type="button"
                onClick={() => onSelectTemplate(template)}
                className={`w-full text-left p-3 rounded-lg border transition-all duration-200 ${
                  isSelected
                    ? 'border-emerald-500 bg-emerald-50 shadow-medium'
                    : 'border-neutral-200 bg-white hover:border-emerald-300 hover:shadow-soft'
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <h3 className="font-semibold text-neutral-900 truncate">{template.name}</h3>
                      {isSelected && (
                        <div className="w-5 h-5 bg-emerald-600 rounded-full flex items-center justify-center shrink-0">
                          <FiCheck className="text-white w-3 h-3" />
                        </div>
                      )}
                    </div>
                    <span className={`inline-block px-2 py-1 rounded-md text-[11px] font-semibold ${badge.color}`}>
                      {badge.name}
                    </span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}

      <p className="text-[12px] text-neutral-500 mt-3">
        Templates store: Meta template name, language code, document URL, and the body text parameter.
      </p>
    </div>
  );
};

export default WhatsAppTemplateSelector;

